
import React from "react";
import { Helmet } from "react-helmet";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import DashboardLayout from "@/components/DashboardLayout";

const Terms = () => {
  return (
    <DashboardLayout>
      <div className="container mx-auto py-12 px-4">
        <Helmet>
          <title>Terms of Service | OpenPipe</title>
        </Helmet>
        <Card className="max-w-4xl mx-auto">
          <CardHeader>
            <CardTitle className="text-3xl font-bold">
              Terms of Service
            </CardTitle>
            <CardDescription>Last Updated: January 30, 2024</CardDescription>
          </CardHeader>
          <CardContent className="legal-page space-y-4">
            <div className="terms-container">
              <p>
                If you signed a separate Cover Page to access the Product with
                the same account, and that agreement has not ended, the terms
                below do not apply to you. Instead, your separate Cover Page
                applies to your use of the Product.
              </p>

              <p>
                This Agreement is between OpenPipe, Inc. and the company or
                person accessing or using the Product. This Agreement consists
                of: (1) the Order Form and (2) the Key Terms, both of which are
                on the Cover Page below, and (3) the Common Paper Cloud Service
                Agreement Standard Terms Version 1.1 ("Standard Terms"). Any
                modifications to the Standard Terms made in the Cover Page will
                control over conflicts with the Standard Terms. Capitalized
                words have the meanings or descriptions given in the Cover Page
                or the Standard Terms.
              </p>

              <p>
                If you are accessing or using the Product on behalf of your
                company, you represent that you are authorized to accept this
                Agreement on behalf of your company. By signing up, accessing,
                or using the Product, Customer indicates its acceptance of this
                Agreement and agrees to be bound by the terms and conditions of
                this Agreement.
              </p>

              <h2>Cover Page</h2>
              <h3>
                <em>Order Form</em>
              </h3>

              <p>
                <strong>Cloud Service:</strong> OpenPipe is a cloud service
                provider for managing datasets, fine-tuning custom models, and
                monitoring model performance in production.
              </p>

              <p>
                <strong>Subscription Start Date:</strong> The Effective Date
              </p>

              <p>
                <strong>Subscription Period:</strong> 1 month(s)
              </p>

              <p>
                <strong>Non-Renewal Notice Period:</strong> At least 30 days
                before the end of the current Subscription Period.
              </p>

              <p>
                <strong>Cloud Service Fees:</strong> Section 5.2 of the Standard
                Terms is replaced with: Certain parts of the Product have
                different pricing plans, which are available at Provider's
                pricing page. Within the Payment Period, Customer will pay
                Provider fees based on the Product tier selected at the time of
                account creation and Customer's usage per Subscription Period.
                Provider may update Product pricing by giving at least 7 days
                notice to Customer (including by email or notification within
                the Product), and the change will apply in the next Subscription
                Period.
              </p>

              <p>
                <strong>Payment Period:</strong> 5 day(s) from the last day of
                the Subscription Period
              </p>

              <p>
                <strong>Invoice Period:</strong> Monthly
              </p>

              <h3>Key Terms</h3>

              <p>
                <strong>Customer:</strong> The company or person who accesses or
                uses the Product. If the person accepting this Agreement is
                doing so on behalf of a company, all use of the word "Customer"
                in the Agreement will mean that company.
              </p>

              <p>
                <strong>Provider:</strong> OpenPipe, Inc.
              </p>

              <p>
                <strong>Effective Date:</strong> The date Customer first accepts
                this Agreement.
              </p>

              <p>
                <strong>General Cap Amount:</strong> The fees paid or payable by
                Customer to provider in the 12 month period immediately before
                the claim
              </p>

              <p>
                <strong>Governing Law:</strong> The laws of the State of
                Delaware
              </p>

              <p>
                <strong>Chosen Courts:</strong> The state or federal courts
                located in Delaware
              </p>

              <p>
                <strong>Notice Address:</strong>
                <br />
                For Provider: notices@openpipe.ai
                <br />
                For Customer: The main email address on Customer's account
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Terms;
